import {NgModule} from '@angular/core';
import {PersistenceComponent} from './persistence.component';
import {CommonModule} from '@angular/common';

import {MockService} from './Connector/mock/mock.service';
import {SapService} from './Connector/sap/sap.service';
import {MongodbService} from './Connector/mongodb/mongodb.service';

import {PersistenceService} from './persistence.service';
import {HttpClientModule} from '@angular/common/http';
import Config from './db.config.json';

@NgModule({

    declarations: [PersistenceComponent],
    imports: [
        CommonModule,
        HttpClientModule
    ],
    providers: [
        {provide: PersistenceService,
         useClass: Config.use === 'mongodb' ? MongodbService :
                   Config.use === 'sap' ? SapService :
                   MockService}
    ],
    exports: [PersistenceComponent]
})
export class PersistenceModule {
}
